import './Footer.css'
function Footer() {
    return (
      <div className="Footer" id='footer'>     
        <h1>Communication matters to start good things/</h1>  
        <h3>I'm currently available for freelance worldwide. Feel free to contact me if you want to collaborate on future projects or have a little chat.</h3>
        <a href='mailto:tamaraiselvan98@gmail.com' className='mail-btn'>Send me a mail!</a>
        <div className='icons'>
            <a href='https://www.linkedin.com/in/tamarai-selvan-ravi-6b5311213/'><i class="fa-brands fa-linkedin"></i></a>
            <a href='https://github.com/tamaraiselva'><i class="fa-brands fa-github"></i></a>
            <a href="tel:9688814221"><i class="fa-solid fa-phone"></i></a>
        </div>
      </div>
      
    );
  }
  
export default Footer;